import FieldSet from '../../FieldSet';

import { ContributorshipName } from './ContributorshipName';

export class IdeaContributorshipFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [ContributorshipName];
  }

  get title() {
    return 'Created by';
  }
}
